<template>
  <v-container flex>
    <v-row>
      <v-col col-6>
        <AddOneObjectModal
          :title="'רחב חדש'"
          :buttonLabel="'הוסף רכב חדש'"
          :addingFunction="'AddUserCar'"
          :fieldsGetter="'userCarsFields'"
          :fieldsGetFunctionName="'userCarsFields'"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        xl="5"
        lg="5"
        md="12"
        sm="12"
        cols="12"
        v-for="(person, key, index) in userCars"
        :key="`${key}`"
      >
        <ShowOneObject
          :id="key"
          :title="`רכב  ${index + 1}`"
          :fieldsGetter="'userCarsFields'"
          :fieldsGetFunctionName="'userCarsFields'"
          :getFieldValuesFunc="'userCar'"
          :updateFieldValuesFunc="'updateUserCar'"
          :removeFieldValuesFunc="'removeUserCar'"
          :addFieldValuesFunc="'AddUserCar'"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ShowOneObject from "@/components/app/MySpace/components/ShowOneObject";
import AddOneObjectModal from "@/components/app/MySpace/components/AddOneObjectModal";
export default {
  name: "MainCars",
  data: () => ({
    addDialog: false,
  }),
  methods: {},
  components: {
    ShowOneObject,
    AddOneObjectModal,
  },
  async created() {
    await this.$store.dispatch("loading", true);
    await this.$store.dispatch("getUserCars");
    await this.$store.dispatch("loading", false);
  },
  computed: {
    ...mapGetters(["loading", "userCars"]),
  },
};
</script>
